module.exports = __webpack_public_path__ + "img/logo.e1ab81d2.png";